import { defineMessages } from '@sm/intl';
import PROJECT_NAME from '~app/pages/Pricing/constants/project';

/**
 * Shared copy file between all the pages
 */

const COPY = defineMessages({
  MAIN_HEADING: {
    id: 'Pricing.copy.SharedPagesHeading',
    defaultMessage: 'Choose a plan that works for you',
    desc: {
      id: 'Pricing.copy.SharedPagesHeading',
      message: '[Type: header][Vis: high] - Primary header for pricing summary page',
      project: PROJECT_NAME,
    },
  },
  DETAILS_HEADING: {
    id: 'Pricing.copy.SharedPagesDetailsHeading',
    defaultMessage: 'Compare our full set of features',
    desc: {
      id: 'Pricing.copy.SharedPagesDetailsHeading',
      message: '[Type: header][Vis: high] - Primary header for pricing details page',
      project: PROJECT_NAME,
    },
  },
  EDUCATIONAL_HEADING: {
    id: 'Pricing.copy.SharedPagesEnterpriseHeading',
    defaultMessage: 'Discounts for Students and Educators',
    desc: {
      id: 'Pricing.copy.SharedPagesEnterpriseHeading',
      message: '[Type: header][Vis: high] - Primary header for pricing educational page',
      project: PROJECT_NAME,
    },
  },
  EDUCATIONAL_SUBHEADING: {
    id: 'Pricing.copy.SharedPagesSubHeading',
    defaultMessage:
      'You must have a valid student, staff, or faculty ID to qualify for discounted pricing. Not eligible for this discount?',
    desc: {
      id: 'Pricing.copy.SharedPagesSubHeading',
      message: '[Type: header][Vis: high] - Subheader for pricing educational page',
      project: PROJECT_NAME,
    },
  },
  VIEW_PRICING: {
    id: 'Pricing.copy.SharedPagesLink',
    defaultMessage: 'View pricing',
    desc: {
      id: 'Pricing.copy.SharedPagesLink',
      message: '[Type: Link][Vis: high] - Link to pricing page',
      project: PROJECT_NAME,
    },
  },
  TEAM_PLANS: {
    id: 'Pricing.copy.SharedPagesTeamPlans',
    defaultMessage: 'Team Plans',
    desc: {
      id: 'Pricing.copy.SharedPagesTeamPlans',
      message: '[Type: Link][Vis.: high] - A link that will direct the user to the Team Plans Pricing Summary page',
      project: PROJECT_NAME,
    },
  },
  INDIVIDUAL_PLANS: {
    id: 'Pricing.copy.SharedPagesIndividualPlans',
    defaultMessage: 'Individual Plans',
    desc: {
      id: 'Pricing.copy.SharedPagesIndividualPlans',
      message:
        '[Type: Link][Vis.: high] - A link that will direct the user to the Individual Plans Pricing Summary page',
      project: PROJECT_NAME,
    },
  },
  ENTERPRISE: {
    id: 'Pricing.copy.SharedPagesEnterprise',
    defaultMessage: 'Enterprise',
    desc: {
      id: 'Pricing.copy.SharedPagesEnterprise',
      message: '[Type: Link][Vis.: high] - A link that will direct the user to the Enterprise Pricing page',
      project: PROJECT_NAME,
    },
  },
  BACK_TO_SUMMARY: {
    id: 'Pricing.copy.SharedPagesBackToSummary',
    defaultMessage: 'Back to pricing summary',
    desc: {
      id: 'Pricing.copy.SharedPagesBackToSummary',
      message: '[Type: Link][Vis.: high] - A link that will direct the user to back to the pricing summary page',
      project: PROJECT_NAME,
    },
  },
  EXPAND_ALL: {
    id: 'Pricing.copy.SharedPagesExpandAll',
    defaultMessage: 'Expand all',
    desc: {
      id: 'Pricing.copy.SharedPagesExpandAll',
      message: '[Type: Link][Vis.: high] - A button discription to Expand all accordions',
      project: PROJECT_NAME,
    },
  },
  COLLAPSE_ALL: {
    id: 'Pricing.copy.SharedPagesCollapseAll',
    defaultMessage: 'Collapse all',
    desc: {
      id: 'Pricing.copy.SharedPagesCollapseAll',
      message: '[Type: Link][Vis.: high] - A button discription to Collapse all accordions',
      project: PROJECT_NAME,
    },
  },
  BASIC: {
    id: 'Pricing.copy.SharedPagesBasic',
    defaultMessage: 'Basic',
    desc: {
      id: 'Pricing.copy.SharedPagesBasic',
      message: '[Type: Heading][Vis.: high] - Basic package name heading',
      project: PROJECT_NAME,
    },
  },
  STANDARD_MONTHLY: {
    id: 'Pricing.copy.SharedPagesStandardMonthly',
    defaultMessage: 'Standard Monthly',
    desc: {
      id: 'Pricing.copy.SharedPagesStandardMonthly',
      message: '[Type: Heading][Vis.: high] - Standard Monthly package name heading',
      project: PROJECT_NAME,
    },
  },
  STANDARD_ANNUAL: {
    id: 'Pricing.copy.SharedPagesStandardAnnual',
    defaultMessage: 'Standard Annual',
    desc: {
      id: 'Pricing.copy.SharedPagesStandardAnnual',
      message: '[Type: Heading][Vis.: high] - Standard Annual package name heading',
      project: PROJECT_NAME,
    },
  },
  STARTER_MONTHLY: {
    id: 'Pricing.copy.SharedPagesStarterMonthly',
    defaultMessage: 'Starter Monthly',
    desc: {
      id: 'Pricing.copy.SharedPagesStarterMonthly',
      message: '[Type: Heading][Vis.: high] - Starter Monthly package name heading',
      project: PROJECT_NAME,
    },
  },
  STARTER_ANNUAL: {
    id: 'Pricing.copy.SharedPagesStarterAnnual',
    defaultMessage: 'Starter Annual',
    desc: {
      id: 'Pricing.copy.SharedPagesStarterAnnual',
      message: '[Type: Heading][Vis.: high] - Starter Annual package name heading',
      project: PROJECT_NAME,
    },
  },
  ADVANTAGE_MONTHLY: {
    id: 'Pricing.copy.SharedPagesAdvantageMonthly',
    defaultMessage: 'Advantage',
    desc: {
      id: 'Pricing.copy.SharedPagesAdvantageMonthly',
      message: '[Type: Heading][Vis.: high] - Advantage Monthly package name heading',
      project: PROJECT_NAME,
    },
  },
  ADVANTAGE_ANNUAL: {
    id: 'Pricing.copy.SharedPagesAdvantageAnnual',
    defaultMessage: 'Advantage Annual',
    desc: {
      id: 'Pricing.copy.SharedPagesAdvantageAnnual',
      message: '[Type: Heading][Vis.: high] - Advantage Annual package name heading',
      project: PROJECT_NAME,
    },
  },
  PREMIER_MONTHLY: {
    id: 'Pricing.copy.SharedPagesPremierMonthly',
    defaultMessage: 'Premier Monthly',
    desc: {
      id: 'Pricing.copy.SharedPagesPremierMonthly',
      message: '[Type: Heading][Vis.: high] - Premier Monthly package name heading',
      project: PROJECT_NAME,
    },
  },
  PREMIER_ANNUAL: {
    id: 'Pricing.copy.SharedPagesPremierAnnual',
    defaultMessage: 'Premier Annual',
    desc: {
      id: 'Pricing.copy.SharedPagesPremierAnnual',
      message: '[Type: Heading][Vis.: high] - Premier Annual package name heading',
      project: PROJECT_NAME,
    },
  },
  TEAM_ADVANTAGE: {
    id: 'Pricing.copy.SharedPagesTeamAdvantage',
    defaultMessage: 'Team Advantage',
    desc: {
      id: 'Pricing.copy.SharedPagesTeamAdvantage',
      message: '[Type: Heading][Vis.: high] - Team Advantage package name heading',
      project: PROJECT_NAME,
    },
  },
  TEAM_PREMIER: {
    id: 'Pricing.copy.SharedPagesTeamPremier',
    defaultMessage: 'Team Premier',
    desc: {
      id: 'Pricing.copy.SharedPagesTeamPremier',
      message: '[Type: Heading][Vis.: high] - Team Premier package name heading',
      project: PROJECT_NAME,
    },
  },
  ENT_PLATINUM: {
    id: 'Pricing.copy.EnterprisePlatinum',
    defaultMessage: 'Enterprise',
    desc: {
      id: 'Pricing.copy.EnterprisePlatinum',
      message: '[Type: Heading][Vis.: high] - Enterprise package name heading',
      project: PROJECT_NAME,
    },
  },
  FLEX: {
    id: 'Pricing.copy.SharedPagesFlex',
    defaultMessage: 'Flex',
    desc: {
      id: 'Pricing.copy.SharedPagesFlex',
      message: '[Type: Heading][Vis.: high] - Flex package name heading',
      project: PROJECT_NAME,
    },
  },
  FORMS: {
    id: 'Pricing.copy.SharedPagesForms',
    defaultMessage: 'Forms',
    desc: {
      id: 'Pricing.copy.SharedPagesForms',
      message: '[Type: Heading][Vis.: high] - Forms package name heading',
      project: PROJECT_NAME,
    },
  },
  PLAN_FEATURES: {
    id: 'Pricing.copy.SharedPlanFeaturesLink',
    defaultMessage: 'See all plan features',
    desc: {
      id: 'Pricing.copy.SharedPlanFeaturesLink',
      message: '[Type: Heading][Vis.: high] - See all plans features link',
      project: PROJECT_NAME,
    },
  },
});

export default COPY;
